export function createSentryRelease({ demo, saas, version }: { demo: boolean; saas: boolean; version: string }) {
    return `passwd-${demo ? 'demo' : saas ? 'saas' : 'app'}@${version}` as const;
}
